<template>
  <div id="app">
    <app-header class="sticky"></app-header>
    <router-view />
    <app-footer class="mt-auto"></app-footer>
  </div>
</template>

<script>
  import Header from '@/components/elements/Header'
  import Footer from '@/components/elements/Footer'
  export default {
    components: {
      'app-header': Header,
      'app-footer': Footer
    }
  }
</script>

<style scoped>
  #app{
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .sticky{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 9;
  }
</style>
